
import { Row, Col, Space } from "antd";
import { Typography } from "@mui/material";
import moment from 'moment';
import { capitalizeFirstLetter } from "../../../../../../helpers/utilities";
import { NavLink } from "react-router-dom";


export const ViewForm = (props) => {
    const { classes, clsx, handleOpen, form, handlePublish, handleValidate, editLoader, createdProduct } = props;
    return (
        <Row align={"bottom"} gutter={50}>
            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
            </Col>
            <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20} className={classes.textAlignRight}>
                {
                    !form?.inApp && form?.batchStatus === 'CREATED' && <Space direction="horizontal" align="center">
                        <NavLink to={'#'}
                            onClick={() => handleOpen()}
                            className={clsx(classes.AddMoreBtn)}>
                            Re-Run
                        </NavLink>
                        <NavLink to={'#'}
                            onClick={() => handlePublish('')}
                            className={clsx(classes.modalBtn, { [classes.loadingA]: editLoader })}>
                            Publish
                        </NavLink>
                    </Space>
                }
                {console.log(form?.isCatalogue)}
                {
                    form?.isCatalogue && form?.inApp && form?.batchStatus === 'CREATED' && !form?.isAccepted && <Space direction="horizontal" align="center">
                        {
                            createdProduct && <NavLink to={'#'}
                                onClick={() => handleValidate('verify')}
                                className={clsx(classes.modalBtn, { [classes.loadingA]: editLoader }, { [classes.disabled]: !form?.isValidate })}>
                                Verify
                            </NavLink>
                        }
                        <NavLink to={'#'}
                            onClick={() => handleValidate('validate-update')}
                            className={clsx(classes.modalBtn, { [classes.loadingA]: editLoader })}>
                            Validate & Update
                        </NavLink>
                        <NavLink to={'#'}
                            onClick={() => handleValidate('validate')}
                            className={clsx(classes.modalBtn, { [classes.loadingA]: editLoader }, { [classes.disabled]: form?.isValidate })}>
                            Validate
                        </NavLink>
                    </Space>
                }
            </Col>
            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Batch Id</Typography>
                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.bold)}>{form?.batchId}</Typography>
            </Col>
            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Created By</Typography>
                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.createdByUser?.business?.name}</Typography>
            </Col>
            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Created Date</Typography>
                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{moment(form?.createTs).format('DD MMM YYYY')}</Typography>
            </Col>
            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Created Time</Typography>
                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{moment(form?.createTs).format('hh:mm:ss')}</Typography>
            </Col>
            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Status</Typography>
                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                    {
                        !form?.inApp ? capitalizeFirstLetter(form?.batchStatus) : <>
                            {
                                form?.isAccepted || !form?.isCatalogue ? 'Completed' : 'Received'
                            }
                        </>
                    }
                </Typography>
            </Col>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.margin20t, classes.bold)}>Query Details</Typography>
            </Col>
            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Catalogue</Typography>
                <Typography variant={'h6'} className={clsx(classes.fonSize14, classes.textFieldColor)}>{form?.isCatalogue ? 'Yes' : 'No'}</Typography>
            </Col>
            {/* <Col span={5}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Catalogue Name</Typography>
                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.catalogueName || '---'}</Typography>
            </Col>
            <Col span={5}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Category Name</Typography>
                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.categoryName || '---'}</Typography>
            </Col> */}
            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Last Published  Date</Typography>
                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.publishedDate ? moment(form?.publishedDate).format('DD MMM YYYY') : '---'}</Typography>
            </Col>
            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Last Published  By</Typography>
                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.publishedBy?.business?.name || '---'}</Typography>
            </Col>
            {
                !form?.inBound && <>
                    {
                        form?.filterBy === 'ALL' ? <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Filter By</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{'All'}</Typography>
                        </Col> : <>
                            {
                                form?.filterBy === 'SPECIFIC' ? <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer Name</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customerName ?? '---'}</Typography>
                                </Col> : <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer Group</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customerGroup ?? '---'}</Typography>
                                </Col>
                            }
                        </>
                    }
                </>
            }
            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>From Date</Typography>
                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.fromDate ? moment(form?.fromDate).format('DD MMM YYYY') : '---'}</Typography>
            </Col>
            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>To Date</Typography>
                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.toDate ? moment(form?.toDate).format('DD MMM YYYY') : '---'}</Typography>
            </Col>
        </Row>
    )
}